import { Layout } from "antd";
import { Navigate } from "react-router";

import { useGetAssetType } from "@/entities/asset-type";
import { getModelLink } from "@/modules/model";
import { isError404 } from "@/services/api";
import { useIdParam } from "@/services/router";

import { AssetTypePageHeader } from "./asset-type-page-header";
import { AssetTypePageTabs } from "./asset-type-page-tabs";

const { Content } = Layout;

const AssetTypePage = () => {
  const id = useIdParam();
  const { isLoading, assetType, error } = useGetAssetType(id);

  if (!id || isError404(error)) {
    return <Navigate to={getModelLink("assettype")} replace />;
  }

  return (
    <>
      <AssetTypePageHeader assetType={assetType} loading={isLoading} />
      <Content>
        <AssetTypePageTabs assetType={assetType} loading={isLoading} />
      </Content>
    </>
  );
};

export default AssetTypePage;
